export const checkIsNumber = (val) => {
  const checkNum = /[^0-9]/g;
  return val.toString().match(checkNum);
};
